export default __webpack_public_path__ + "static/media/whiteheart-01.c1b3734c.png";